<template>
    <div :class="{ 'timeline-row': timeline, 'with-padding': !timeline }">
        <div v-if="timeline" class="timeline-icon" @click="removeItem">
            <div class="bg-primary-300">
                <i class="fa" :class="getIcon" :style="getStyle"></i>
            </div>
        </div>

        <div class="panel panel-flat timeline-content">
            <div class="panel-body no-padding">
                <div v-if="item.type === 'video'" class="video-container">
                    <iframe allowfullscreen="" frameborder="0" mozallowfullscreen=""
                            :src="item.content" webkitallowfullscreen=""></iframe>
                </div>
                <blockquote v-else-if="item.type === 'instagram-post'" class="instagram-media" data-instgrm-captioned data-instgrm-version="7" style="border:0; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);">
                    <div style="padding:8px;">
                        <div style="background:#F8F8F8; line-height:0; margin-top:40px; padding:62.5% 0; text-align:center; width:100%;">
                            <div></div></div> <p style=" margin:8px 0 0 0; padding:0 4px;"> <a :href="item.content" style=" color:#000; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none; word-wrap:break-word;" target="_blank"></a></p>
                    </div>
                </blockquote>
                <div v-else-if="item.type === 'spotify'">
                    <iframe  :src="item.content" width="100%" height="380" frameborder="0" allowtransparency="true"></iframe>
                </div>
                <div v-else-if="item.type === 'soundcloud'">
                    <iframe width="100%" height="166" scrolling="no" frameborder="no" :src="`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${item.content}&color=0066cc`"></iframe>
                </div>
                <ul v-else-if="item.type === 'image'" class="media-list">
                    <p v-if="item.description">{{item.description}}</p>
                    <div class="thumbnail">
                        <a :href="item.content">
                            <img :src="item.content" alt="">
                        </a>
                    </div>
                </ul>
                <ul v-else-if="item.type === 'url'" class="media-list">
                    <li class="media stack-media-on-mobile">
                        <div class="media-left">
                            <div class="thumb">
                                <a :href="item.content" target="_blank">
                                    <img :src="item.image" class="img-responsive img-rounded media-preview" alt="">
                                    <span class="zoom-image"><i class="fa fa-link"></i></span>
                                </a>
                            </div>
                        </div>

                        <div class="media-body">
                            <h6 class="media-heading"><a :href="item.content" target="_blank">{{item.title}}</a></h6>
                            <ul class="list-inline list-inline-separate text-muted mb-5">
                                <li><i class="fa fa-tag position-left"></i> Something interesting</li>
                            </ul>
                            {{item.description}}
                        </div>
                    </li>
                </ul>

                <div v-if="item.description && item.type !== 'url'" class="panel-footer">
                    <div class="heading-elements">
                        <span class="heading-text">{{ item.description }}</span>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['item', 'timeline'],

        computed: {
            getIcon () {
                switch(this.item.type) {
                    case 'video':
                        return 'fa-ticket';
                    case 'instagram':
                        return 'fa-instagram';
                    case 'spotify':
                        return 'fa-spotify';
                    case 'soundcloud':
                        return 'fa-soundcloud';
                    case 'url':
                        return 'fa-link';
                    case 'image':
                        return 'fa-image';
                    default:
                        return 'fa-puzzle-piece';
                }
            },
            getStyle () {
                var padding = '11px',
                    fontSize = '24px';
                switch(this.item.type) {
                    case 'video':
                        padding = '9px';
                        break;
                    case 'url':
                    case 'spotify':
                        padding = '10px';
                        break;
                }
                return { paddingLeft: padding, fontSize: fontSize };
            }
        },

        methods: {
            removeItem () {
                this.$emit('itemRemoved', this.item);
            }
        }
    }
</script>

<style scoped>
    .with-padding {
        padding: 20px;
    }
    .timeline-icon i:hover::before {
        content: "\f014";
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// Item.vue?3afd9620